import { makeStyles, mergeClasses, tokens } from '@fluentui/react-components';
import { ChevronDownFilled } from '@fluentui/react-icons'
import { noop } from 'lodash-es';
import { ReactNode } from 'react';

export interface INavSectionProps {
  children: ReactNode;
  collapsed?: boolean;
  title: ReactNode;
  onToggle?: () => void;
  className?: string;
  active?: boolean;
}

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: tokens.colorNeutralBackground3,
  },
  headerContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: '1em',
    paddingRight: '1em',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: tokens.colorNeutralBackground2Hover
    }
  },
  header: {
    flexGrow: 1,
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightBold,
    userSelect: 'none'
  },
  navItemsOpen: {
    display: 'block',
    fontSize: tokens.fontSizeBase300,
    '& a': {
      color: tokens.colorNeutralForeground1,
      textDecoration: 'none',
    },
    '& a:hover': {
      color: tokens.colorBrandForegroundLinkHover
    }
  },
  navItemsCollapsed: {
    display: 'none'
  },
  chevronOpen: {
    transform: 'rotate(0deg)'
  },
  chevronCollapsed: {
    transform: 'rotate(-90deg)'
  },
  active: {
    backgroundColor: tokens.colorNeutralBackground2Selected,
    "&:hover": {
      backgroundColor: tokens.colorNeutralBackground2Selected
    }
  }
})

export function NavSection(props: INavSectionProps) {
  const {
    children,
    title,
    collapsed = false,
    onToggle = noop,
    className,
    active
  } = props;

  const isActive = active ?? false;
  const classes = useStyles();
  const rootClassName = mergeClasses(className, classes.container, (isActive && collapsed) ? classes.active : undefined);
  return (
    <div className={rootClassName}>
      <span aria-hidden="true" className={classes.headerContainer} onClick={onToggle}>
        <h3 className={classes.header}>
          {title}
        </h3>
        <ChevronDownFilled aria-hidden={true} className={collapsed ? classes.chevronCollapsed : classes.chevronOpen} />
      </span>
      <div className={collapsed ? classes.navItemsCollapsed : classes.navItemsOpen}>
        {children}
      </div>
    </div>
  )
}
